import React, { useState, useEffect } from 'react';
import { AnalyticsMobileNav } from './MobileNav';

const UsageAnalytics = ({ analytics }) => {
  const [chartData, setChartData] = useState([]);
  
  useEffect(() => {
    if (!analytics) return;
    
    const log = analytics.usageLog || [];
    const history = analytics.clipHistory || [];
    
    // Build last 30 days chart data
    const days = [];
    const now = new Date();
    for (let i = 29; i >= 0; i--) {
      const d = new Date(now);
      d.setDate(d.getDate() - i);
      const key = d.toISOString().split('T')[0];
      days.push({ date: key, label: d.getDate() + '/' + (d.getMonth()+1), videos: 0, clips: 0 });
    }
    
    // Fill in usage log data
    log.forEach(entry => {
      const key = new Date(entry.date).toISOString().split('T')[0];
      const day = days.find(d => d.date === key);
      if (day) {
        day.videos += 1;
        day.clips += entry.clips || 3;
      }
    });
    
    // Also count from clip history
    history.forEach(entry => {
      const key = new Date(entry.date).toISOString().split('T')[0];
      const day = days.find(d => d.date === key);
      if (day && log.length === 0) {
        day.videos += 1;
        day.clips += entry.clips || 3;
      }
    });
    
    setChartData(days);
  }, [analytics]);

  const maxClips = Math.max(1, ...chartData.map(d => d.clips));
  const totalVideos = chartData.reduce((a, d) => a + d.videos, 0);
  const totalClips = chartData.reduce((a, d) => a + d.clips, 0);
  const activeDays = chartData.filter(d => d.videos > 0).length;
  const avgPerDay = activeDays > 0 ? (totalClips / activeDays).toFixed(1) : '0';

  return (
    <><AnalyticsMobileNav />
    <div>
      {/* Stats Row */}
      <div style={{display:'flex',gap:'8px',marginBottom:'16px',flexWrap:'wrap'}}>
        {[
          { label: 'Videos', value: totalVideos, color: '#8b5cf6' },
          { label: 'Clips', value: totalClips, color: '#06b6d4' },
          { label: 'Active Days', value: activeDays, color: '#10b981' },
          { label: 'Avg/Day', value: avgPerDay, color: '#f59e0b' }
        ].map((stat, i) => (
          <div key={i} style={{flex:1,minWidth:'65px',padding:'10px 8px',background:'rgba(255,255,255,0.03)',borderRadius:'10px',textAlign:'center',border:'1px solid rgba(255,255,255,0.06)'}}>
            <div style={{color:stat.color,fontSize:'18px',fontWeight:'800'}}>{stat.value}</div>
            <div style={{color:'#64748b',fontSize:'9px',fontWeight:'600',textTransform:'uppercase',marginTop:'2px'}}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Bar Chart */}
      <div style={{marginBottom:'8px'}}>
        <div style={{color:'#94a3b8',fontSize:'11px',fontWeight:'600',marginBottom:'8px'}}>Last 30 Days Activity</div>
        <div style={{display:'flex',alignItems:'flex-end',gap:'2px',height:'80px',padding:'0 2px'}}>
          {chartData.map((day, i) => {
            const height = maxClips > 0 ? Math.max(2, (day.clips / maxClips) * 70) : 2;
            const isToday = i === chartData.length - 1;
            return (
              <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'flex-end',height:'100%',position:'relative'}} title={day.label + ': ' + day.videos + ' videos, ' + day.clips + ' clips'}>
                <div style={{
                  width:'100%',
                  height: height + 'px',
                  borderRadius:'3px 3px 0 0',
                  background: day.clips > 0 
                    ? isToday ? 'linear-gradient(180deg,#8b5cf6,#06b6d4)' : 'linear-gradient(180deg,rgba(139,92,246,0.7),rgba(6,182,212,0.7))'
                    : 'rgba(255,255,255,0.04)',
                  transition: 'height 0.3s ease',
                  minHeight: '2px'
                }}></div>
              </div>
            );
          })}
        </div>
        {/* X axis labels - show every 5th day */}
        <div style={{display:'flex',gap:'2px',marginTop:'4px'}}>
          {chartData.map((day, i) => (
            <div key={i} style={{flex:1,textAlign:'center',fontSize:'8px',color: i % 5 === 0 || i === chartData.length-1 ? '#475569' : 'transparent',fontWeight:'500'}}>
              {day.label}
            </div>
          ))}
        </div>
      </div>

      {/* Peak Day */}
      {(() => {
        const peak = chartData.reduce((best, d) => d.clips > best.clips ? d : best, { clips: 0, label: '-' });
        if (peak.clips === 0) return null;
        return (
          <div style={{padding:'8px 12px',background:'rgba(139,92,246,0.06)',borderRadius:'8px',border:'1px solid rgba(139,92,246,0.1)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{color:'#94a3b8',fontSize:'11px',fontWeight:'600'}}>Peak day: {peak.label}</span>
            <span style={{color:'#a78bfa',fontSize:'12px',fontWeight:'700'}}>{peak.clips} clips</span>
          </div>
        );
      })()}
    </div>
  </>
  );
};

export default UsageAnalytics;
